// components/SubscriptionDialog.jsx
import React from "react";
import { Modal, Button, Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaLock, FaArrowLeft, FaBolt } from "react-icons/fa";

const SubscriptionDialog = ({
  show,
  onHide,
  onActivate,
  serviceName = "this",
}) => {
  const navigate = useNavigate();

  const handleCancel = () => {
    onHide();
    // Optional: Go back in history
    // if (window.history.length > 1) {
    //   window.history.back();
    // }
  };

  const handleActivate = () => {
    onHide();
    if (onActivate) {
      onActivate();
    } else {
      navigate("/subscription");
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {}}
      centered
      backdrop="static"
      keyboard={false}
      size="md"
      dialogClassName="border-0"
    >
      <Modal.Body className="p-0">
        <Card className="border-0 shadow-lg" style={{ borderRadius: "16px" }}>
          <Card.Body className="p-4">
            {/* Icon Section */}
            <div className="text-center mb-4">
              <div
                className="mx-auto d-flex align-items-center justify-content-center"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(220, 53, 69, 0.1)",
                  fontSize: "48px",
                  color: "#dc3545",
                }}
              >
                <FaLock />
              </div>
            </div>

            {/* Title */}
            <h3
              className="text-center fw-bold mb-3"
              style={{ color: "#212529" }}
            >
              Access Denied
            </h3>

            {/* Message */}
            <p
              className="text-center text-muted mb-4"
              style={{ fontSize: "0.95rem", lineHeight: "1.5" }}
            >
              You need to activate your one-time premium subscription to access
              {serviceName ? ` ${serviceName} ` : " "}services.
            </p>

            <hr className="my-4" />

            {/* Action Buttons */}
            <div className="d-grid gap-3 d-md-flex justify-content-md-center">
              {/* Cancel Button */}
              <Button
                variant="outline-secondary"
                className="d-flex align-items-center justify-content-center gap-2 flex-grow-1"
                onClick={handleCancel}
                style={{
                  borderRadius: "12px",
                  padding: "12px 16px",
                  borderColor: "#dee2e6",
                  color: "#6c757d",
                  fontWeight: "500",
                }}
              >
                <FaArrowLeft style={{ fontSize: "14px" }} />
                Cancel
              </Button>

              {/* Activate Button */}
              <Button
                variant="primary"
                className="d-flex align-items-center justify-content-center gap-2 flex-grow-1"
                onClick={handleActivate}
                style={{
                  borderRadius: "12px",
                  padding: "12px 16px",
                  backgroundColor: "#0d6efd",
                  borderColor: "#0d6efd",
                  fontWeight: "500",
                  boxShadow: "0 4px 6px rgba(13, 110, 253, 0.2)",
                }}
              >
                <FaBolt style={{ fontSize: "14px", color: "white" }} />
                Activate Now
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

export default SubscriptionDialog;
